import { withI18n } from 'react-i18next';
import tablePagination from './TablePagination';

export const pureComponent = tablePagination;
export default withI18n()(tablePagination);
